import { toLegacyDetail, toLegacyPaginated, v1Delete, v1Get, v1Post, v1Put } from '@/services/v1Api';

// Get all crew types
export const getCrewTypes = async (filters = {}) => {
    try {
        console.log('[crewTypesService] Fetching crew types with filters:', filters);

        const params = {};
        if (filters.search) params.search = filters.search;
        if (filters.sort_by) params.sort_by = filters.sort_by;
        if (filters.sort_order) params.sort_order = filters.sort_order;
        if (filters.per_page) params.per_page = filters.per_page;
        if (filters.page) params.page = filters.page;

        const { data, meta } = await v1Get('/api/v1/crew-types', params);
        const result = toLegacyPaginated(data, meta);
        console.log('[crewTypesService] Successfully fetched crew types:', result);
        return result;
    } catch (error) {
        console.error('[crewTypesService] Error fetching crew types:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            filters: filters
        });
        throw error;
    }
};

// Get crew type by ID
export const getCrewTypeById = async (id) => {
    try {
        console.log(`[crewTypesService] Fetching crew type with ID: ${id}`);
        const { data } = await v1Get(`/api/v1/crew-types/${id}`);
        const result = toLegacyDetail(data);
        console.log(`[crewTypesService] Successfully fetched crew type ${id}:`, result);
        return result;
    } catch (error) {
        console.error(`[crewTypesService] Error fetching crew type ${id}:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        throw error;
    }
};

// Create new crew type
export const createCrewType = async (crewTypeData) => {
    try {
        console.log('[crewTypesService] Creating crew type:', crewTypeData);
        const { data } = await v1Post('/api/v1/crew-types', crewTypeData);
        const result = toLegacyDetail(data);
        console.log('[crewTypesService] Successfully created crew type:', result);
        return result;
    } catch (error) {
        console.error('[crewTypesService] Error creating crew type:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            crewTypeData: crewTypeData
        });
        throw error;
    }
};

// Update crew type
export const updateCrewType = async (id, crewTypeData) => {
    try {
        console.log(`[crewTypesService] Updating crew type ${id}:`, crewTypeData);
        const { data } = await v1Put(`/api/v1/crew-types/${id}`, crewTypeData);
        const result = toLegacyDetail(data);
        console.log(`[crewTypesService] Successfully updated crew type ${id}:`, result);
        return result;
    } catch (error) {
        console.error(`[crewTypesService] Error updating crew type ${id}:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            crewTypeData: crewTypeData
        });
        throw error;
    }
};

// Delete crew type
export const deleteCrewType = async (id) => {
    try {
        console.log(`[crewTypesService] Deleting crew type ${id}`);
        await v1Delete(`/api/v1/crew-types/${id}`);
        const result = { success: true };
        console.log(`[crewTypesService] Successfully deleted crew type ${id}:`, result);
        return result;
    } catch (error) {
        console.error(`[crewTypesService] Error deleting crew type ${id}:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        throw error;
    }
};
